import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { getPatientOrdoclicUrl } from '../../../data/ordoclic'
import { UserFriendlyError } from '../../../model/Error'
import { ordoclicKeys } from './ordoclic.keys'

interface GetPatientOrdoclicUrlParams {
  enabled: boolean
  patientId?: number
}

export const useGetPatientOrdoclicUrl = ({
  patientId,
  enabled = true,
}: GetPatientOrdoclicUrlParams) => {
  const queryKey = useMemo(() => ordoclicKeys.detail(patientId), [patientId])

  const queryResult = useQuery({
    queryKey,
    queryFn: async () => {
      if (!patientId) return

      const { data, ok } = await getPatientOrdoclicUrl(patientId)

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          "Une erreur s'est produite",
          "Impossible d'accéder à l'e-prescription",
        )
      }
      return data
    },
    enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  })

  return queryResult
}
